import { AxiosResponse } from 'axios';
import { FilterOptions } from '../../hooks/useFilters';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/config';

export class ConfigService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene la información de una configuración por su ID
     *
     * @EN Gets the information of a configuration by its ID
     * 
     * @param id
     */
    // -------------------------------------------------------------------------------------------------------------
    getConfig = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { id },
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene el listado de configuraciones
     *
     * @EN Gets the list of configurations
     * 
     * @param filters
     */
    // -------------------------------------------------------------------------------------------------------------
    listConfigs = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Obtiene la información de una configuración por su ID
     *
     * @EN Gets the information of a configuration by its ID
     * 
     * @param id
     */
    // -------------------------------------------------------------------------------------------------------------
    getConfigById = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { id },
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Crea una nueva configuración
     *
     * @EN Creates a new configuration
     * 
     * @param config
     */
    // -------------------------------------------------------------------------------------------------------------
    createConfig = async (config: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: config,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
    

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Edita una configuración existente
     *
     * @EN Edits an existing configuration
     * 
     * @param config
     */
    // -------------------------------------------------------------------------------------------------------------
    editConfig = async (config: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: config,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Elimina una configuración existente
     *
     * @EN Deletes an existing configuration
     * 
     * @param id
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteConfig = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { id },
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES Elimina varias configuraciones existentes en el sistema
     *
     * @EN Deletes multiple existing configurations from the system
     * 
     * @param configIds
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiConfigs = async (configIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { ids: configIds },
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


}
